export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="14" fill="#14b8a6" />
    <path d="M13 35V24a11 11 0 0 1 22 0v11h-6.2V24a4.8 4.8 0 0 0-9.6 0v11H13Z" fill="#fff" />
    <circle cx="24" cy="11.5" r="2.4" fill="#f59e0b" />
  </svg>
);

export const Logo = ({ variant = "light" }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="nidoria-logo">
    <LogoMark />
    <span
      className={`font-serif text-[1.35rem] font-semibold tracking-tight ${
        variant === "light" ? "text-white" : "text-[#12263a] dark:text-[#f7f4ee]"
      }`}
    >
      Nidoria
    </span>
  </span>
);

export default Logo;
